import classes from './costTab.module.css';

type CostHeaderBlockProps = {
  title: string;
  value: string;
  subtext?: string;
  dataCy?: string;
};

const CostHeaderBlock = ({
  title,
  value,
  subtext,
  dataCy,
}: CostHeaderBlockProps) => (
  <div className={classes.headerInfoBlock} data-cy={dataCy}>
    <div className={classes.headerSectionTitle}>{title}</div>
    <div className={classes.headerSectionInfo}>{value}</div>
    {subtext && <div className={classes.conversionSubtext}>{subtext}</div>}
  </div>
);

export default CostHeaderBlock;
